import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";

import { errorHandler } from "../../helpers/errorHandler";
import { FallbackComponent } from "../general/FallbackComponent";
import { RoutesProvider } from "./RoutesProvider";

export const AppProviders = ({ children }) => (
	<ErrorBoundary onError={errorHandler} FallbackComponent={FallbackComponent}>
		<RoutesProvider>{children}</RoutesProvider>
	</ErrorBoundary>
);

AppProviders.propTypes = {
	children: PropTypes.node.isRequired,
};
